module.exports = __webpack_public_path__ + "media/images/lb/789-af7898c2ff7a3e8d762c24b8619a4040.svg";